export default __webpack_public_path__ + "static/2-a5c1f825998c6e32a6ea83b3056c7f91.svg";